import { createShader, colorUniform } from "./ShaderBase.js";

export const oceanShader = createShader({
  customizable: [
    { uniform: "uColorDeep", label: "Deep", default: "#0a2463" },
    { uniform: "uColorSurface", label: "Surface", default: "#3e92cc" },
  ],

  uniforms: {
    uPixelSize: { value: 12.0 },
    uScale: { value: 0.8 },
    uSpeed: { value: 0.4 },
    uColorDeep: colorUniform("#0a2463"),
    uColorSurface: colorUniform("#3e92cc"),
    uColorFoam: colorUniform("#d8e2dc"),
    uWaveIntensity: { value: 0.3 },
  },

  fragmentUniforms: `
    uniform vec3 uColorDeep;
    uniform vec3 uColorSurface;
    uniform vec3 uColorFoam;
    uniform float uWaveIntensity;
  `,

  fragmentBody: `
    // Animated wave distortion
    float wave1 = snoise(vec3(pixelatedPos.x * 0.5 + uTime * uSpeed, pixelatedPos.y * 0.3, uTime * 0.1));
    float wave2 = snoise(vec3(pixelatedPos.x * 0.3 - uTime * uSpeed * 0.7, pixelatedPos.y * 0.5, uTime * 0.15));
    float waves = (wave1 + wave2) * 0.5;

    // Depth gradient with wave displacement
    float depth = pixelatedPos.y * 0.02 + 0.5 + waves * uWaveIntensity;
    depth = clamp(depth, 0.0, 1.0);

    // Mix deep and surface colors
    vec3 color = mix(uColorDeep, uColorSurface, depth);

    // Foam/sparkle on wave peaks
    float foam = snoise(pixelatedPos * 15.0 + vec3(uTime * uSpeed * 2.0));
    float foamThreshold = 0.7 - waves * 0.3;
    float foamAmount = smoothstep(foamThreshold, foamThreshold + 0.1, (foam + 1.0) * 0.5);
    color = mix(color, uColorFoam, foamAmount * 0.6);

    // Subtle caustic light patterns
    float caustic = snoise(pixelatedPos * 8.0 + vec3(uTime * uSpeed * 0.5, uTime * uSpeed * 0.3, 0.0));
    caustic = (caustic + 1.0) * 0.5;
    color += vec3(0.1, 0.15, 0.2) * caustic * 0.2;

    gl_FragColor = vec4(color, 1.0);
  `,
});
